import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import PublicLayout from "@/components/PublicLayout";
import HomePage from "@/pages/HomePage";
import RecipesPage from "@/pages/RecipesPage";
import RecipeDetailPage from "@/pages/RecipeDetailPage";
import WorldRecipesPage from "@/pages/WorldRecipesPage";
import CountryPage from "@/pages/CountryPage";
import GuidesPage from "@/pages/GuidesPage";
import GuideDetailPage from "@/pages/GuideDetailPage";
import AboutPage from "@/pages/AboutPage";
import MentionsLegalesPage from "@/pages/MentionsLegalesPage";
import CGUPage from "@/pages/CGUPage";
import PolitiqueConfidentialitePage from "@/pages/PolitiqueConfidentialitePage";

import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminRecipes from "@/pages/admin/AdminRecipes";
import AdminGuides from "@/pages/admin/AdminGuides";
import AdminLogs from "@/pages/admin/AdminLogs";
import AdminNewsletter from "@/pages/admin/AdminNewsletter";
import AdminBatchAdapt from "@/pages/admin/AdminBatchAdapt";
import AdminImportMarkdown from "@/pages/admin/AdminImportMarkdown";
import AdminImageLogs from "@/pages/admin/AdminImageLogs";
import AdminEditRecipe from "@/pages/admin/AdminEditRecipe";
import AdminMigrateImages from "@/pages/admin/AdminMigrateImages";

import useAnalytics from "@/hooks/useAnalytics";

function ScrollAndAnalytics() {
  const location = useLocation();
  useAnalytics();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollAndAnalytics />
        <Routes>
          {/* Public */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/recettes" element={<RecipesPage />} />
            <Route path="/recettes/:slug" element={<RecipeDetailPage />} />
            <Route path="/cuisines-du-monde" element={<WorldRecipesPage />} />
            <Route path="/cuisines-du-monde/:countrySlug" element={<CountryPage />} />
            <Route path="/categories/:categorySlug" element={<RecipesPage />} />
            <Route path="/guides" element={<GuidesPage />} />
            <Route path="/guides/:slug" element={<GuideDetailPage />} />
            <Route path="/a-propos" element={<AboutPage />} />
            <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
            <Route path="/cgu" element={<CGUPage />} />
            <Route path="/politique-confidentialite" element={<PolitiqueConfidentialitePage />} />
          </Route>

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="recipes" element={<AdminRecipes />} />
            <Route path="recipes/:id/edit" element={<AdminEditRecipe />} />
            <Route path="batch" element={<AdminBatchAdapt />} />
            <Route path="import-markdown" element={<AdminImportMarkdown />} />
            <Route path="guides" element={<AdminGuides />} />
            <Route path="logs" element={<AdminLogs />} />
            <Route path="image-logs" element={<AdminImageLogs />} />
            <Route path="migrate-images" element={<AdminMigrateImages />} />
            <Route path="newsletter" element={<AdminNewsletter />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
